import enTranslations from './translations/en/index.json';
import esTranslations from './translations/es/index.json';

const translations = {
  en: enTranslations,
  es: esTranslations
};

export default translations;